import type { SupportedLocaleType } from './supported-locales';

export const DEFAULT_LOCALE: SupportedLocaleType = 'en';
